import { lineFont } from '../state';

export function keyboardModeTab(
  use: 'numbers' | 'alphabet' | 'functions',
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  animated = false,
  animatedColor: string,
  w: number,
  h: number,
  fontScalar?: number
): void {
  fontScalar = fontScalar || 1;
  const r = 8;

  ctx.save();

  ctx.fillStyle = animated ? animatedColor : 'lightgray';

  ctx.beginPath();
  ctx.moveTo(x + w / 2, y);
  ctx.arcTo(x + w - r / 2, y, x + w - r / 2, y + h / 2, r); // top-right
  ctx.lineTo(x + w - r / 2, y + h - r); // right
  ctx.arc(x + w + r / 2, y + h - r, r, Math.PI, Math.PI / 2, true); // bottom-right
  ctx.lineTo(x, y + h); // bottom
  ctx.arc(x - r / 2, y + h - r, r, Math.PI / 2, 0, true); // bottom-left
  ctx.lineTo(x + r / 2, y + h / 2); // left
  ctx.arcTo(x + r / 2, y, x + w / 2, y, r); // top-left
  ctx.closePath();

  ctx.fill();

  ctx.restore();

  ctx.save();

  ctx.beginPath();
  ctx.fillStyle = animated ? 'white' : 'gray';

  if (use == 'numbers' || use == 'alphabet') {
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.font = 18 * fontScalar + 'px ' + lineFont;

    x = 0.5 * w;
    y = 0.5 * h + fontScalar;

    ctx.fillText(use === 'numbers' ? '123' : 'ABC', x, y);
  } else if (use == 'functions') {
    ctx.font = 11 * fontScalar + 'px ' + lineFont;

    // draw a fraction symbol
    x = 20 * fontScalar;
    y = 12 * fontScalar;

    ctx.fillText('\u25A2', x, y);

    y += 4 * fontScalar;

    ctx.lineWidth = 2;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.moveTo(x - 3 * fontScalar, y);
    ctx.lineTo(x + 14 * fontScalar, y);
    ctx.closePath();
    ctx.stroke();

    y += 12 * fontScalar;
    ctx.fillText('\u25A2', x, y);

    // draw a power symbol
    x += 25 * fontScalar;
    y -= 7 * fontScalar;

    ctx.fillText('\u25A2', x, y);

    ctx.font = 8 * fontScalar + 'px ' + lineFont;

    x += 11 * fontScalar;
    y -= 8 * fontScalar;

    ctx.fillText('\u25A2', x, y);

    // ellipsis
    ctx.font = 20 * fontScalar + 'px ' + lineFont;

    x += 12 * fontScalar;
    y += 8 * fontScalar;

    ctx.fillText('...', x, y);
  }

  ctx.restore();
}
